<a href="{{data.item_url}}" [attr.disabled]="disabled ? 'disabled': 'false'" target="{{ getTarget() }}" class="{{ data.item_css }} {{ classname }} {{disabled ? 'disabled':''}}" *ngIf="data.item_title">
    {{data.item_title}}
</a>